import { ReactNode } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { isPositiveNumber } from "et3-type-guards";

import i18n from "../../../../../constants/i18n";
import { DEFAULT_ET3_PICKER_SINGLE_VALUE } from "../../../../../constants/picker-entries-constants";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import getKhattabatMatchingStore from "../../../../../stores/khattabat-stores/matching-stores";

const PaidUserSelect = withLiteObserverAndTheme<{
  showCount?: boolean;
  action?: ReactNode;
}>((props) => {
  const { showCount = false, action } = props;
  const {
    currentClientInformation,
    getPaidUserOptions,
    getCurrentPaidUserPickerValue,
    setCurrentUserInformation,
    isCurrentUserExist
  } = getKhattabatMatchingStore();
  const { gender, userStatus } = currentClientInformation.get();
  const currentPaidUser = getCurrentPaidUserPickerValue();
  const paidUserOptions = getPaidUserOptions(showCount);
  const selectedPaidUser =
    paidUserOptions.find((option) => option.value === currentPaidUser.value) ??
    null;

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Grid container spacing={2} alignItems="flex-end">
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Autocomplete
            size="small"
            options={paidUserOptions}
            value={selectedPaidUser}
            isOptionEqualToValue={(option, value) =>
              option.value === value.value
            }
            onChange={(_, option) =>
              setCurrentUserInformation(
                option ?? DEFAULT_ET3_PICKER_SINGLE_VALUE
              )
            }
            renderOption={(optionProps, option) => {
              const { key, ...liProps } = optionProps;
              return (
                <Box
                  component="li"
                  key={key}
                  {...liProps}
                  sx={{ display: "flex", gap: 1 }}
                >
                  {option.label}
                  {isPositiveNumber(option.badge) ? (
                    <Chip size="small" color="error" label={option.badge} />
                  ) : null}
                </Box>
              );
            }}
            renderInput={(params) => (
              <TextField {...params} label={i18n.get("PAID_USERS")} />
            )}
          />
        </Grid>
        {isCurrentUserExist() && (
          <Grid size={{ xs: 12, sm: 6, md: "grow" }}>
            <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap" }}>
              <Chip
                variant="outlined"
                label={`${i18n.get("GENDER")}: ${
                  gender === "m" ? "male" : gender === "f" ? "female" : ""
                }`}
              />
              <Chip
                variant="outlined"
                color={userStatus === "active" ? "success" : "error"}
                label={`${i18n.get("STATUS")}: ${userStatus}`}
              />
            </Stack>
          </Grid>
        )}
        {action ? (
          <Grid size={{ xs: 12, md: "auto" }} sx={{ ml: { md: "auto" } }}>
            {action}
          </Grid>
        ) : null}
      </Grid>
    </Paper>
  );
});

export default PaidUserSelect;
